module.exports = __webpack_public_path__ + "static/media/finance.61d61024.svg";